/**
 * Get localized field from a database document.
 * When language is 'en', tries to use the '_en' suffixed field.
 * Falls back to the original Bangla field if English version doesn't exist.
 */
export const getField = (item, field, language) => {
  if (!item) return '';
  if (language === 'en') {
    const enField = `${field}_en`;
    if (item[enField]) return item[enField];
  }
  return item[field] || '';
};

/**
 * Get localized steps from a guide document.
 */
export const getSteps = (guide, language) => {
  if (!guide) return [];
  if (language === 'en' && guide.steps_en && guide.steps_en.length > 0) {
    return guide.steps_en;
  }
  return guide.steps || [];
};
